import Swiper, { Navigation, Pagination } from "swiper";

const topicsslider = document.querySelectorAll(".js-topicsslider");
if (topicsslider.length > 0) {
    topicsslider.forEach((slider) => {
        new Swiper(slider, {
            modules: [Pagination, Navigation],
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                clickable: true,
                el: ".swiper-pagination",
                type: "bullets",
                renderBullet: (index, className) =>
                    `<div class="${className}"><div class="swiper-pagination-bullet_inner"></div></div>`,
            },
            autoHeight: false,
            slidesPerView: 1,
            spaceBetween: 32,
            breakpoints: {
                1024: {
                    spaceBetween: 48,
                },
            },
            on: {
                init: function () {
                    if (this.slides.length <= 1) {
                        this.allowSlidePrev = this.allowSlideNext = false;
                        this.el.querySelector(".swiper-pagination").style.display = "none";
                        this.el.querySelector(".swiper-button-next").style.display = "none";
                        this.el.querySelector(".swiper-button-prev").style.display = "none";
                    }
                },
            },
        });
    });
}
